<template>
    <div>
        <div class="row">
            <div class="mb-3 col-md-5">
                <input type="text" class="form-control" id="label_tissu" placeholder="Nom du type de tissu"
                    v-model="formData.label" required>
                <small class="text-danger" v-if="errors['label']">{{ errors['label'][0] }}</small>
            </div>
            <div class="mb-3 col-md-5">
                <textarea type="text" class="form-control" id="description_tissu"
                    placeholder="Description du type de tissu" v-model="formData.description" required></textarea>
                <small class="text-danger" v-if="errors['description']">{{ errors['description'][0] }}</small>
            </div>
            <div class="mb-3 col-md-2 d-flex align-items-end">
                <button class="btn btn-success w-100" @click="save"><i
                        class="bi bi-check-circle me-1"></i>Enregistrer</button>
            </div>
        </div>
    </div>
</template>

<script>
import formMixin from '@/mixins/formMixin';
export default {
    name: "TissuTypeForm",
    mixins: [formMixin],
    data: () => ({
        url: "type_tissus",
    }),
}
</script>